import RadioGroup, {
    RadioGroupProps,
} from '@totallymoney/ui/components/RadioGroup'
import { FieldProps, getIn } from 'formik'
import * as React from 'react'

function FormikRadioGroup<
    Value extends string | number | readonly string[] | undefined = any
>({ field, form, ...props }: FieldProps<Value> & RadioGroupProps) {
    const validationMessage = getIn(form.errors, field.name) as string
    const isTouched = getIn(form.touched, field.name) as boolean

    return (
        <RadioGroup
            {...field}
            validationMessage={validationMessage}
            touched={isTouched}
            {...props}
        />
    )
}

export default FormikRadioGroup
